const state = {
    sessionId: "",
    appId: "000000",
    user: {
        sessionId: "",
        receiveWebsocketNotify: false
    },

    hiddenNav: false,

    historyList: [
    ],
    //范围时间选择器
    pickerOptions: {
        shortcuts: [
            {
                text: "今天",
                onClick(picker) {
                    const start = new Date(
                        new Date(
                            new Date().toLocaleDateString()
                        ).getTime()
                    );
                    const end = new Date(
                        new Date(
                            new Date().toLocaleDateString()
                        ).getTime() +
                        (24 * 60 * 60 * 1000 - 1)
                    );

                    picker.$emit("pick", [start, end]);
                }
            },
            {
                text: "昨天",
                onClick(picker) {
                    const start = new Date(
                        new Date(
                            new Date().toLocaleDateString()
                        ).getTime() -
                        24 * 60 * 60 * 1000
                    );
                    const end = new Date(
                        new Date(
                            new Date().toLocaleDateString()
                        ).getTime() -
                        24 * 60 * 60 * 1000 +
                        (24 * 60 * 60 * 1000 - 1)
                    );

                    picker.$emit("pick", [start, end]);
                }
            },
            {
                text: "过去7天",
                onClick(picker) {
                    const start = new Date(
                        new Date(
                            new Date().toLocaleDateString()
                        ).getTime() -
                        24 * 60 * 60 * 1000 * 7
                    );
                    const end = new Date(
                        new Date(
                            new Date().toLocaleDateString()
                        ).getTime() -
                        24 * 60 * 60 * 1000 +
                        (24 * 60 * 60 * 1000 - 1)
                    );
                    picker.$emit("pick", [start, end]);
                }
            },
            {
                text: "过去30天",
                onClick(picker) {
                    const start = new Date(
                        new Date(
                            new Date().toLocaleDateString()
                        ).getTime() -
                        24 * 60 * 60 * 1000 * 30
                    );
                    const end = new Date(
                        new Date(
                            new Date().toLocaleDateString()
                        ).getTime() -
                        24 * 60 * 60 * 1000 +
                        (24 * 60 * 60 * 1000 - 1)
                    );
                    picker.$emit("pick", [start, end]);
                }
            }
        ]
    },


    // 如果父导航有child  则会忽略父导航上的router
    navigationList: [
        {
            icon: 'el-icon-service',
            text: '客服中心',
            nav: 'service',
            role: ['admin', 'manager', 'service'],
            open: true,
            child: [
                {
                    text: "接待中",
                    nav: "",
                    router: "/",
                    role: [],
                },
                {
                    text: "已接待",
                    nav: "overChat",
                    router: "/service/overChat",
                    role: [],
                },
                {
                    text: "知识库",
                    nav: "knowledge",
                    router: "/service/knowledge",
                    role: ['admin', 'manager'],
                },
                {
                    text: "常见问题",
                    nav: "commonProblem",
                    router: "/service/commonProblem",
                    role: ['admin', 'manager'],
                },
            ]
        },
        {
            icon: 'el-icon-service',
            text: '工单管理',
            nav: 'workOrder',
            role: [],
            open: true,
            child: [
                {
                    text: "全部工单",
                    nav: "allWorkOrder",
                    router: "/workOrder/allWorkOrder",
                    role: ['admin', 'manager', 'ticket_manager'],
                },
                {
                    text: "我的工单",
                    nav: "myWorkOrder",
                    router: "/workOrder/myWorkOrder",
                    role: [],
                },
            ]
        },
        {
            icon: 'el-icon-service',
            text: '私聊',
            nav: 'chat',
            role: ['admin', 'manager'],
            open: true,
            child: [
                {
                    text: "聊天记录",
                    nav: "chat",
                    router: "/chat",
                    role: [],
                },
                {
                    text: "对话统计",
                    nav: "statistics",
                    router: "/chat/statistics",
                    role: [],
                },
                // {
                //     text: "设置",
                //     nav: "setting",
                //     router: "/chat/setting",
                //     role: [],
                // },
            ]
        },
        {
            icon: 'el-icon-info',
            text: '会话标签',
            nav: 'historyTag',
            router: "/historyTag",
            role: ['admin', 'manager', 'service'],
        },
        {
            icon: 'el-icon-setting',
            text: '设置',
            nav: 'setting',
            role: ['admin'],
            child: [
                {
                    text: "用户管理",
                    nav: "staff",
                    router: "/setting/staff",
                    role: [],
                },
                {
                    text: "客服组管理",
                    nav: "groups",
                    router: "/setting/groups",
                    role: [],
                },
                {
                    text: "工单组管理",
                    nav: "taskGroup",
                    router: "/setting/taskGroup",
                    role: [],
                },
                {
                    text: "应用管理",
                    nav: "app",
                    router: "/setting/app",
                    role: [],
                },
                {
                    text: "基础配置",
                    nav: "onOff",
                    router: "/setting/onOff",
                    role: [],
                },
                {
                    text: "时间计划",
                    nav: "time",
                    router: "/setting/time",
                    role: [],
                },
                {
                    text: "标签管理",
                    nav: "messageTag",
                    router: "/setting/messageTag",
                    role: [],
                },
                {
                    text: "咨询分类管理",
                    nav: "consultClassify",
                    router: "/setting/consultClassify",
                    role: [],
                }
            ]
        },
        {
            icon: 'el-icon-date',
            text: '管理',
            nav: 'system',
            role: ['admin'],
            child: [
                {
                    text: "消息管理",
                    nav: "message",
                    router: "/system/message",
                    role: [],
                },
                {
                    text: "过滤词管理",
                    nav: "keyWord",
                    router: "/system/keyWord",
                    role: [],
                },
                {
                    text: "过滤IP管理",
                    nav: "ip",
                    router: "/system/ip",
                    role: [],
                },
            ]
        },
        {
            icon: 'el-icon-date',
            text: '工作报表',
            nav: 'workReport',
            role: ['admin', 'manager'],
            child: [
                {
                    text: "工作量统计",
                    nav: "workload",
                    router: "/workReport/workload",
                    role: [],
                },
                {
                    text: "咨询分类统计",
                    nav: "consultClassifyReport",
                    router: "/workReport/consultClassifyReport",
                    role: [],
                },
                {
                    text: "分时统计",
                    nav: "trendCount",
                    router: "/workReport/trendCount",
                    role: [],
                },
                {
                    text: "工作质量概览",
                    nav: "workQuality",
                    router: "/workReport/workQuality",
                    role: [],
                },
                {
                    text: "工作质量详情",
                    nav: "workQualityDetail",
                    router: "/workReport/workQualityDetail",
                    role: [],
                },
            ]
        },
    ]
}

export default state



// WEBPACK FOOTER //
// ./src/vue/vuex/state.js